import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../../core/shared/hooks/useApi.js';
import type { ModuleLabelsConfig } from '../../../core/shared/hooks/useModuleLabels.js';

export interface StoreSettings {
  bedrijf: {
    naam: string;
    adres: string;
    telefoon: string;
    email: string;
    btwNummer: string;
  };
  buitendienst: {
    trajectTemplates: string[];
    defaultChecklistItems: string[];
    autoNotificaties: boolean;
  };
  communicatie: {
    emailSignatuur: string;
    smsTemplate: string;
    whatsappTemplate: string;
  };
  notificaties: {
    emailNotificaties: boolean;
    pushNotificaties: boolean;
    databusEvents: string[];
  };
  integraties: {
    wmsWebhookUrl: string;
    databusApiKey: string;
    makecomWebhookUrl: string;
  };
  moduleLabels?: Partial<ModuleLabelsConfig>;
}

export function useStoreSettings() {
  return useQuery({
    queryKey: ['store-settings'],
    queryFn: () => apiFetch<StoreSettings>('/api/store-settings'),
  });
}

export function useUpdateStoreSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<StoreSettings>) =>
      apiFetch<StoreSettings>('/api/store-settings', { method: 'PUT', body: JSON.stringify(data) }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['store-settings'] }); },
  });
}

export function useTestConnection() {
  return useMutation({
    mutationFn: (url: string) =>
      apiFetch<{ success: boolean; status: number; message: string }>(
        '/api/store-settings/test-connection',
        { method: 'POST', body: JSON.stringify({ url }) },
      ),
  });
}
